import checkCondition from './checkCondition';
import { Customer } from './checkoutState';
import { AbTest } from './config';

const getCookie = (cookieName: string) => {
  const cookies = Object.fromEntries(
    document.cookie.split('; ').map(rawCookie => {
      const equalSignIndex = rawCookie.indexOf('=');
      return [rawCookie.slice(0, equalSignIndex), rawCookie.slice(equalSignIndex + 1)];
    })
  );
  return cookies[cookieName];
};

const consentCookie = getCookie('OptanonConsent');

let cookieConsent: boolean;

export const setCookieConsent = (consentFromAttribute: boolean) => {
  cookieConsent = consentFromAttribute;
};

export const hasCookieConsent = () =>
  cookieConsent ||
  (!!consentCookie &&
    (consentCookie.includes('1clss:1') || consentCookie.includes('1clss%3A1')) &&
    (consentCookie.includes('am:1') || consentCookie.includes('am%3A1')));

export const setActiveAbTests = (abTests: AbTest[], customer?: Customer) => {
  if (!hasCookieConsent()) {
    return;
  }

  abTests.forEach(abTest => {
    const localStorageKey = `coAbTest:${abTest.experimentId}`;
    const areConditionsMet = !checkCondition(abTest.conditions, { customerGroup: customer?.groups ?? [] });
    if (!areConditionsMet || localStorage.getItem(localStorageKey)) {
      return;
    }
    const randomValue = Math.random() * 100;
    const isTestActive = randomValue < abTest.percentage;
    localStorage.setItem(localStorageKey, isTestActive ? 'active' : 'inactive');
  });
};

export const isAbTestActive = (experimentId: string) => localStorage.getItem(`coAbTest:${experimentId}`) === 'active';
